/**
 * This class calls Api Gateway to fetch Authentication information.
 * We pass down all the cookies to API gateway including Auth Token.
 * API Gateway communicates with BCRest to fetch Auth info
 */

import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import httpClient from 'superagent';

/**
 * Loads common user info
 *
 * @param  {object} - ApiClient - this is a stateful client which knows about the baseApiURL passed down.
 * @return {promise}
 */
function loadUser(apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/sessions/current`;
  return apiClient.get(route);
}

function login(username, password, apiClient) {
  const route = apiClient.route`/libraries/${':librarySubdomain'}/sessions`;
  const data = { username, password };

  return apiClient.post(route, data).pipe(
    mergeMap(auth => {
      const isValidSsoUrl = auth.ssoUrl && auth.ssoUrl.indexOf('https') === 0;

      if (isValidSsoUrl) {
        // We don't care about the result of the SSO request.
        // It shouldn't affect the user from logging on our end
        httpClient
          .get(auth.ssoUrl)
          .withCredentials()
          .end();
      }

      return of(auth);
    })
  );
}

export default {
  loadUser,
  login
};
